import React from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
interface ConfirmDialogProps {
  open: boolean;
  title: string;
  description: string;
  confirmLabel?: string;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}
export function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel = 'Eliminar',
  loading = false,
  onCancel,
  onConfirm
}: ConfirmDialogProps) {
  return <Modal open={open} onClose={onCancel} title={title} footer={<div className="flex justify-end gap-2" data-id="element-57" data-mp="2vatoxcfu1lao">
          <Button variant="ghost" onClick={onCancel} disabled={loading} data-id="element-58" data-mp="2hkq9b4bgkpu7">
            Cancelar
          </Button>
          <Button variant="destructive" onClick={onConfirm} loading={loading} data-id="element-59" data-mp="2mjjpx5m1kwyl">
            {confirmLabel}
          </Button>
        </div>} data-id="element-56" data-mp="2rbt8g0ktuuqu">
      <p className="text-sm text-muted-foreground" data-id="element-60" data-mp="3a7t71u8b8wje">{description}</p>
    </Modal>;
}